let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c0FMs")).then(() => parcelRequire('cX5zm'));